import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Strings from '../../../../Strings';
import TableWidget from '../component/TableWidget';
import { actions } from '../redux/actions';
import { EDIT_SCHEDULE } from '../../Schedules/redux/constants';
import { openModalAction } from '../../../../actions/modal';
import DropdownMenu from '../../../../components/DropdownMenu/DropdownMenu';
import {
  assignCapConfirmation,
  deleteScheduleConfirmation,
  getScheduleDetailsRows,
  unassignCapConfirmation,
} from './scheduleDetails';

function MedicationWidget({ isCollapsible = false, hideActions = false, simplifiedVersion = false, ...props }) {
  const { devices, isLoading, schedule, patient } = props;

  const onDelete = () => props.openConfirmModal(deleteScheduleConfirmation(patient.id, schedule));

  const onCapClicked = value => {
    if (value === 'none') return;
    props.openConfirmModal(assignCapConfirmation(props.patient.id, props.schedule, value));
  };

  const onCapDelete = () => props.openConfirmModal(unassignCapConfirmation(props.patient.id, props.schedule));

  const addCapButton = (
    <div className="addMenu">
      <DropdownMenu
        icon="plus"
        options={
          devices?.length > 0 ?
            devices.map(device => ({ label: device, onSelect: () => onCapClicked(device) })) :
            ([{ label: Strings.noCapAvailable, onSelect: () => {} }])
        }
        buttonTestId={`add-cap-button[${props.schedule?.medicationName}]`}
      />
    </div>
  );

  const cap = (
    <div className="cap-and-delete">
      <div>{props.schedule?.capId}</div>
      {!hideActions && (
        <div className="buttons-icon-container">
          <div className="icon delete" onClick={onCapDelete} data-testid={`delete-cap-button[${props.schedule?.capId}]`} />
        </div>
      )}
    </div>
  );

  const buttons = [
    { icon: 'delete', onClick: onDelete, id: `delete-schedule-button-[${schedule.medicationName}]` },
    { icon: 'edit', onClick: () => props.onEditMedicine(props.patient, props.schedule), id: `edit-schedule-button-[${schedule.medicationName}]` },
  ];

  const tableData = getScheduleDetailsRows({
    schedule,
    capCell: schedule?.capId ? cap : devices && !hideActions ? addCapButton : '-',
    patientEnrollments: props.patientEnrollments,
    withTimezone: !simplifiedVersion,
  });
  return (
    <TableWidget
      title={schedule.medicationName}
      buttons={hideActions ? undefined : buttons}
      data={tableData}
      isLoading={isLoading}
      firstColumnClassName={`medication-details-col ${simplifiedVersion ? 'simplified' : ''}`}
      isCollapsible={isCollapsible}
    />
  );
}

MedicationWidget.propTypes = {
  isLoading: PropTypes.any,
  patient: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  medicationDetails: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    schedule: PropTypes.string,
    time: PropTypes.any,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    offset: PropTypes.array,
    adherence: PropTypes.number,
    scheduleTimezone: PropTypes.string,
    capId: PropTypes.string,
  }),
  schedule: PropTypes.any,
  patientEnrollments: PropTypes.arrayOf({
    enrollmentId: PropTypes.string,
    name: PropTypes.string,
    subprogram: PropTypes.string,
  }),
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  devices: PropTypes.array,
  openConfirmModal: PropTypes.func,
  onEditMedicine: PropTypes.func,
  isCollapsible: PropTypes.bool,
  hideActions: PropTypes.bool,
  simplifiedVersion: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  openConfirmModal: data => dispatch(openModalAction('confirmation-modal', data)),
  onEditMedicine: (patient, schedule) =>
    dispatch(
      openModalAction('edit-rpm-schedule', {
        patient,
        schedule,
        actionType: EDIT_SCHEDULE,
        onSuccess: () => dispatch(actions.getMedications(patient.id)),
      }),
    ),
});

export default connect(null, mapDispatchToProps)(MedicationWidget);
